import React, { useState } from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { t } from "i18next";
import { Col, Row } from "react-bootstrap";
import PageHeader from "../../../Layouts/PageHeader/PageHeader";
import styles from "./Dashboard.module.scss";
import ReportFilterRaceSummary from "../Report/ReportFilterRaceSummary";
import ReportFilterDailySummary from "../Report/ReportFilterDailySummary";
import ReportFilterMonthlySummary from "../Report/ReportFilterMonthlySummary";
import ReportFilterCustomSummary from "../Report/ReportFilterCustomSummary";
import ReportFilterPortDues from "../Report/ReportFilterPortDues";
import ReportFilterTrips from "../Report/ReportFilterTrips";
import ReportTicketSummary from "../Report/ReportTicketSummary";
import ReportFilterVessels from "../Report/ReportFilterVessels"
import ReportRevenueSummary from "../Report/ReportRevenueSummary"
import ReportItineraryPassengerSummary from "../Report/ReportItineraryPassengerSummary"
import ReportItineraryVesselSummary from "../Report/ReportItineraryVesselSummary"




import { ToastContainer } from "react-toastify";

function Dashboard(props) {
    const [key, setKey] = useState('race');

    const TABS = [
        { key: "race", label: "Riepilogo Corsa", Component: ReportFilterRaceSummary },
        { key: "daily", label: "Riepilogo Giornaliero", Component: ReportFilterDailySummary },
        { key: "monthly", label: "Riepilogo Mensile", Component: ReportFilterMonthlySummary },
        { key: "custom", label: "Riepilogo Personalizzato", Component: ReportFilterCustomSummary },
        { key: "port", label: "Riepilogo Diritti Portuali", Component: ReportFilterPortDues },
        { key: "trips", label: "Riepilogo Itinerario", Component: ReportFilterTrips },
        { key: "ticket_summary", label: "ticket_summary", Component: ReportTicketSummary },
        { key: "vessels_summary", label: "vessels_summary", Component: ReportFilterVessels },
        { key: "revenue_summary", label: "revenue_summary", Component: ReportRevenueSummary },
        { key: "passenger_summary", label: "passenger_summary", Component: ReportItineraryPassengerSummary },
        { key: "itinerary_vessel", label: "itinerary_vessel", Component: ReportItineraryVesselSummary }


    ];

    const renderTabs = () => {
        return (<Tabs
            id="dashboard-tabs"
            activeKey={key}
            onSelect={setKey}
            className={styles.tabs}
        >
            {TABS.map(({ key: tabKey, label, Component }) => (
                <Tab key={tabKey} eventKey={tabKey} title={t(label)}>
                    <div className={styles.tabContent}>
                        <Component {...props} />
                    </div>
                </Tab>
            ))}
        </Tabs>)
    }

    return (
        <div className={styles.dashboard}>
            <ToastContainer
                position="bottom-center"
                autoClose={3000}
                newestOnTop
                pauseOnHover
                style={{ zIndex: 1000000 }}
            />

            <PageHeader titles={t("title_dashboard")} />

            <Row>
                <Col xl={12}>
                    {renderTabs()}
                </Col>
            </Row>
        </div>
    );

}

export default Dashboard;

/*



 */
